import { render, staticRenderFns } from "./ImgInfo.vue?vue&type=template&id=da3088c6&scoped=true&"
import script from "./ImgInfo.vue?vue&type=script&lang=js&"
export * from "./ImgInfo.vue?vue&type=script&lang=js&"
import style0 from "./ImgInfo.vue?vue&type=style&index=0&id=da3088c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3088c6",
  null
  
)

export default component.exports